import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
// import { type AllProductsQueryParams } from '@/common/types/product.type';
import { type MultiLevelMenuItem } from '@/common/types/multi-level-menu.type';
import { type FilteredDataType } from '@/features/store/types/filter.type';
import { useRouter } from 'nextjs-toploader/app';
import { isDesktop, isMobile } from 'react-device-detect';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button/button.component';
import CardDivider from '@/common/components/card-divider';
import Drawer from '@/common/components/drawer/drawer.component';
import FilterMultiLevelMenu from '@/common/components/filter-multi-level-menu';
import Switch from '@/common/components/switch/switch.component';
import Text from '@/common/components/text/text.component';
import {
  // orderByLookup,
  orderMock,
} from '@/common/constants/filter-product-list.constant';
import {
  createMenuItems,
  type InputType,
} from '@/common/utils/create-menu-items.utility.ts';
import { createQueryStringUtility } from '@/common/utils/create-query-string.utility';
import Header from './header.component';

interface Props {
  categoryList: MultiLevelMenuItem[];
  filteredData: FilteredDataType;
  setFilteredData: React.Dispatch<React.SetStateAction<FilteredDataType>>;
  children?: React.ReactNode;
}

function useIsClientReady() {
  const [isClientReady, setIsClientReady] = useState(false);

  useEffect(() => {
    setIsClientReady(true);
  }, []);

  return isClientReady;
}

function Filter({
  categoryList,
  filteredData,
  setFilteredData,
  children,
}: Props) {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const pathName = usePathname();
  const [menuLevel, setMenuLevel] = useState<number>(0);
  const isClientReady = useIsClientReady();

  const handleClick = () => {
    setQueryParams();
    setOpen(false);
  };

  const setQueryParams = () => {
    const formatedCategory = filteredData.category.map((item) => item.value);
    const queryString = createQueryStringUtility({
      ...(formatedCategory.length && {
        category: `${formatedCategory.join('-')}`,
      }),
      ...(filteredData.orderBy.value && {
        orderBy: `${filteredData.orderBy.value}`,
      }),
      ...(filteredData.isDiscounted && {
        isDiscounted: `${filteredData.isDiscounted}`,
      }),
      ...(filteredData.isAvailable && {
        isAvailable: `${filteredData.isAvailable}`,
      }),
    });

    router.replace(`${pathName}${queryString}`, { scroll: false });
  };

  const onSelectMenuItem = (
    item: MultiLevelMenuItem | MultiLevelMenuItem[]
  ) => {
    setFilteredData((prevState) => {
      if (Array.isArray(item)) {
        return {
          ...prevState,
          category: item,
        };
      } else {
        return {
          ...prevState,
          orderBy: item,
        };
      }
    });
  };

  const filterMenu = () => {
    const menu = !isDesktop
      ? [
          {
            label: 'مرتب سازی بر اساس',
            value: 'ORDERBY',
            subNestedItem: [...orderMock],
          },
        ]
      : [
          {
            label: 'مرتب سازی بر اساس',
            value: 'ORDERBY',
            inputType: 'title' as InputType,
          },
          ...orderMock,
        ];
    if (!isDesktop)
      menu.unshift({
        label: 'دسته‌بندی محصولات',
        value: 'CATEGORY',
        subNestedItem: [...categoryList],
      });
    return createMenuItems(menu);
  };

  if (!isClientReady) return null;

  return (
    <>
      {isMobile ? <Header setOpen={setOpen} filtered={false} /> : null}

      <div
        onClick={() => {
          setOpen(true);
        }}
      >
        {children}
      </div>
      <Drawer
        rootClassName="lg:!right-0 lg:!translate-x-0 lg:!w-full"
        className="category-drawer flex flex-col justify-between rounded-t-3xl lg:rounded-none"
        placement={!isDesktop ? 'bottom' : 'right'}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        height={'auto'}
      >
        <div className="max-lg:h-[calc(100%-80px)] flex flex-col justify-between overflow-y-auto lg:!h-full">
          <div>
            <FilterMultiLevelMenu
              menuLevel={menuLevel}
              isDesktop={isDesktop}
              setMenuLevel={setMenuLevel}
              onSelect={onSelectMenuItem}
              title="فیلتر و مرتب سازی"
              items={filterMenu()}
              defaultChecked={{
                category: filteredData.category,
                orderBy: filteredData.orderBy,
              }}
            />
            {menuLevel === 0 && (
              <>
                <div className="flex items-center justify-between py-[12px] lg:!pb-[16] lg:!pt-0">
                  <Text className="text-sm font-normal">فقط دارای تخفیف</Text>
                  <Switch
                    id="discount"
                    checked={filteredData.isDiscounted}
                    onChange={(e) => {
                      setFilteredData({
                        ...filteredData,
                        ...{ isDiscounted: e },
                      });
                    }}
                    label=""
                  />
                </div>
                <CardDivider
                  type="item"
                  itemClassName="hidden lg:!flex !px-0"
                />
                <div className="flex items-center justify-between pb-[12px] lg:!py-[16px]">
                  <Text className="text-sm font-normal">فقط محصولات موجود</Text>
                  <Switch
                    id="available"
                    checked={filteredData.isAvailable}
                    onChange={(e) => {
                      setFilteredData({
                        ...filteredData,
                        ...{ isAvailable: e },
                      });
                    }}
                    label=""
                  />
                </div>
              </>
            )}
          </div>
          {menuLevel === 0 && (
            <AnalyticsWrapper analytics={['store-submit-filter-v1']}>
              <Button
                type="black"
                onClick={handleClick}
                id="store-submit-filter-v1"
                className="w-full"
              >
                اعمال
              </Button>
            </AnalyticsWrapper>
          )}
        </div>
      </Drawer>
    </>
  );
}

export default Filter;
